var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-speed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 8.648v6.704c0 .511.6.822 1.063.544l5.616-3.352a.626.626 0 0 0 0-1.094l-5.616-3.346C9.6 7.826 9 8.137 9 8.648"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11 1a1 1 0 0 1 1-1c6.627 0 12 5.373 12 12s-5.373 12-12 12a1 1 0 1 1 0-2c5.523 0 10-4.477 10-10S17.523 2 12 2a1 1 0 0 1-1-1",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.66.228C10.416.078 11.2 0 12 0a1 1 0 1 1 0 2q-1.006.002-1.953.19A1 1 0 1 1 9.66.228M6.72 2.296a1 1 0 0 1-.275 1.388 10.1 10.1 0 0 0-2.761 2.76 1 1 0 0 1-1.662-1.112 12.1 12.1 0 0 1 3.31-3.31 1 1 0 0 1 1.387.274M1.402 8.872a1 1 0 0 1 .787 1.175 10.1 10.1 0 0 0 0 3.906 1 1 0 0 1-1.962.388 12.1 12.1 0 0 1 0-4.682 1 1 0 0 1 1.175-.787m.893 8.409a1 1 0 0 1 1.388.274c.73 1.091 1.67 2.03 2.76 2.761a1 1 0 1 1-1.112 1.662 12.1 12.1 0 0 1-3.31-3.31 1 1 0 0 1 .274-1.387m6.576 5.316a1 1 0 0 1 1.175-.787c.631.124 1.284.19 1.953.19a1 1 0 1 1 0 2c-.8 0-1.583-.078-2.34-.228a1 1 0 0 1-.788-1.175",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-speed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgIcSpeed;